export const NEARBY_SEARCH_RADIUS_OPTIONS = [
  {
    key: '5',
    text: '5 Miles',
    value: 5,
  },
  {
    key: '10',
    text: '10 Miles',
    value: 10,
  },
  {
    key: '25',
    text: '25 Miles',
    value: 25,
  },
  {
    key: '50',
    text: '50 Miles',
    value: 50,
  },
  {
    key: '100',
    text: '100 Miles',
    value: 100,
  },
]
